// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"494":"397c34ca2cbe854e","763":"09e7068c31ce7471"}[chunkId] + ".js";
};